/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { Company } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector, useAppDispatch } from 'src/app/hooks'
import { showNotification } from 'src/core/helpers'
import { FormLabels, Loader } from 'src/components'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Row, Col, Divider, Button, Upload, Tooltip } from 'antd'
import { editCompanyDetails, resetEditCompanyState } from 'src/features'
import DeleteButton from './DeleteButton/DeleteButton'
import PreviewButton from './PreviewButton/PreviewButton'

interface PropsType {
  company: Company
}

const CompanyFilesForm = ({ company }: PropsType) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isImageVisible, setIsImageVisible] = useState(false)

  const {
    loading: loadingEdition,
    success: successEdition
  } = useAppSelector((state) => state.companies.editCompany)

  const handleFileChange = (key: string) => ({ file }) => {
    const formData = new FormData()
    formData.append(key, file)
    dispatch(editCompanyDetails(company.id, formData))
  }

  const beforeUploadImage = (file: any) => {
    const payload = new FormData()
    payload.set('logo', file)
    dispatch(editCompanyDetails(company.id, payload))
    return false
  }

  const getFileList = (file: any) => {
    return file ? [file] : []
  }

  useEffect(() => {
    if (successEdition) {
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetEditCompanyState())
    }
    return (() => {
      dispatch(resetEditCompanyState())
    })
  }, [successEdition])


  return (
    <div>
      {loadingEdition && <Loader /> }
      {/* Representative Id Document */}
      <Row>
        <Col xs={24} lg={12}>
          <FormLabels
            title={t('settings.RepresentativeDocument')}
            subtitle={t('settings.ChoseDocument')}
          />
        </Col>
        <Col xs={24} lg={12}>
          <Upload beforeUpload={() => false}
            accept='application/pdf'
            fileList={getFileList(company?.representative_id_document_file)}
            onChange={handleFileChange('representative_id_document')}
            showUploadList={{
              showDownloadIcon: true,
              showRemoveIcon: false
            }}>
            <Button icon={<UploadOutlined />}>{t('settings.UpdateDocument4')}</Button>
          </Upload>
          {company?.representative_id_document && (
            <DeleteButton value={'representative_id_document'} company={company}/>
          )}
        </Col>
      </Row>

      <Divider />

      {/* Deed of incorporation document */}
      <Row>
        <Col xs={24} lg={12}>
          <FormLabels
            title={t('settings.DeedDocument')}
            subtitle={t('settings.ChoseDocument')}
          />
        </Col>
        <Col xs={24} lg={12}>
          <Upload beforeUpload={() => false}
            accept='application/pdf'
            fileList={getFileList(company?.deed_of_incorporation_document_file)}
            onChange={handleFileChange('deed_of_incorporation_document')}
            showUploadList={{
              showDownloadIcon: true,
              showRemoveIcon: false
            }}>
            <Button icon={<UploadOutlined />}>{t('settings.UpdateDocument3')}</Button>
          </Upload>
          {company?.deed_of_incorporation_document && (
            <DeleteButton value={'deed_of_incorporation_document'} company={company}/>
          )}
        </Col>
      </Row>

      <Divider />

      {/* Deed of incorporation document */}
      <Row>
        <Col xs={24} lg={12}>
          <FormLabels
            title={t('settings.PowerDocument')}
            subtitle={t('settings.ChoseDocument')}
          />
        </Col>
        <Col xs={24} lg={12}>
          <Upload beforeUpload={() => false}
            accept='application/pdf'
            fileList={getFileList(company?.power_of_attorney_document_file)}
            onChange={handleFileChange('power_of_attorney_document')}
            showUploadList={{
              showDownloadIcon: true,
              showRemoveIcon: false
            }}>
            <Button icon={<UploadOutlined />}>{t('settings.UpdateDocument2')}</Button>
          </Upload>
          {company?.power_of_attorney_document && (
            <DeleteButton value={'power_of_attorney_document'} company={company}/>
          )}
        </Col>
      </Row>

      <Divider />

      {/* Vat number document */}
      <Row>
        <Col xs={24} lg={12}>
          <FormLabels
            title={t('settings.VatDocument')}
            subtitle={t('settings.ChoseDocument')}
          />
        </Col>
        <Col xs={24} lg={12}>
          <Upload beforeUpload={() => false}
            accept='application/pdf'
            fileList={getFileList(company?.vat_number_document_file)}
            onChange={handleFileChange('vat_number_document')}
            showUploadList={{
              showDownloadIcon: true,
              showRemoveIcon: false
            }}>
            <Button icon={<UploadOutlined />}>{t('settings.UpdateDocument1')}</Button>
          </Upload>
          {company?.vat_number_document && (
            <DeleteButton value={'vat_number_document'} company={company}/>
          )}
        </Col>
      </Row>

      <Divider />

      {/* Logo */}
      <Row>
        <Col xs={24} lg={12}>
          <FormLabels
            title={t('settings.CompanyLogo')}
            subtitle={t('settings.ChoseLogo')}
          />
        </Col>
        <Col xs={24} lg={4}>
          <Upload
            accept='image/*'
            name='avatar'
            listType='picture-card'
            className='avatar-uploader'
            showUploadList={false}
            beforeUpload={beforeUploadImage}
          >
            {company?.logo ? (
              <>
                <Tooltip title={t('settings.UpdateLogo')} color={'blue'}>
                  <Image
                    layout='intrinsic'
                    width='50'
                    loader={() => company.logo}
                    height='50'
                    src={company.logo}
                    priority={true}
                    alt='company-logo'
                  />
                </Tooltip>
              </>
            ) : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{t('developers.Upload')}</div>
              </div>
            )}
          </Upload>
          {company?.logo && (
            <Row className='ml-5'>
              <Col xs={6} lg={6} md={6}>
                <PreviewButton visible={isImageVisible} setVisible={setIsImageVisible} src={company.logo}/>
              </Col>
              <Col xs={18} lg={18} md={18}>
                <DeleteButton value={'logo'} company={company}/>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default CompanyFilesForm
